/**
 * This represents the data needed by the audio player for visual representation of data
 * provided by a PlayObject
 */
export class AudioPlayer {
  constructor() {
    this.volume = 75
    this.title = ''
    this.image = ''
    this.currentTimeInSeconds = 0
    this.durationInSeconds = 0
    this.playerEpisodeCurrentTime = ''
    this.playerEpisodeDuration = ''
    this.showAudioPlayer = false
    this.playerSliderStyle = { backgroundColor: '#E9705E' }
    this.volumeSliderStyle = { backgroundColor: '#F6D67B' }
  }
}



// WEBPACK FOOTER //
// ./src/components/AudioPlayer/model/AudioPlayer.js